import { Edge, Node } from "@antv/x6"
import { NodeAttrEditor } from "./NodeAttrEditor"
import { MMNumberEditor } from "./editors/MMNumberEditor"
import { InfoCard } from "../UnitPanel/components/common/InfoCard"
import { FCustomNozzles } from "./editors/CustomNozzles"
import { DefaultNozzles } from "./editors/DefaultNozzles"
import { getTagIdByNodeId } from "@/components/FlowSheetEditor/nodes"
import { useGraphInstance } from "@antv/xflow"
import { useMemo } from "react"
import { LineNozzles } from "./editors/LineNozzles"
import { LinePanel } from "../BasicNodePanel/LinePane"
import { NodeShapes } from "@/components/FlowSheetEditor/services/modal"
import { LineJumpEditor } from "./editors/LineJumpEditor"

interface NodeSettingProps {
  unit: Node | Edge
}

export const NodeSetting = (props: NodeSettingProps) => {
  const {unit} = props
  const isNode = unit.isNode()
  const graph = useGraphInstance()
  const tagId = getTagIdByNodeId(unit.id)

  const tagCell = useMemo(() => {
    return graph ? graph.getCellById(tagId) : null;
  }, [graph, tagId])

  const getNodeContent = () => {
    const node = unit as Node
    const size = node.getSize()
    const position = node.position()

    const tagPos = (tagCell as Node)?.position()

    return <div>
      <InfoCard title='Position'>
        <NodeAttrEditor
          node={node}
          attrPath="position/x"
          Editor={MMNumberEditor} label="X" initValue={position.x} addonAfter='mm' />
        <NodeAttrEditor
          attrPath="position/y"
          node={node} Editor={MMNumberEditor} label="Y" initValue={position.y} addonAfter='mm' />
      </InfoCard>
      {unit.shape !== NodeShapes.LineJump && <InfoCard title='Size' className="mt-1">
        <NodeAttrEditor
          attrPath="size/width"
          node={node} Editor={MMNumberEditor} label="Width" initValue={size.width} />
        <NodeAttrEditor
          attrPath="size/height"
          node={node} Editor={MMNumberEditor} label="Height" initValue={size.height} />
      </InfoCard>}
      {unit.shape === NodeShapes.LineJump && <LineJumpEditor node={unit as Node} />}
      {tagCell && <InfoCard title='Tag Position' className="mt-1">
        <NodeAttrEditor
          attrPath="position/x"
          node={tagCell as Node} Editor={MMNumberEditor} label="Tag X" initValue={tagPos.x} />
        <NodeAttrEditor
          attrPath="position/y"
          node={tagCell as Node} Editor={MMNumberEditor} label="Tag Y" initValue={tagPos.y} />
      </InfoCard>}
      {
        unit.shape !== NodeShapes.LineJump && <>
          <div className="mt-1">
            <DefaultNozzles node={node} />
          </div>
          <div className="mt-1">
            <FCustomNozzles node={node} />
          </div>
          <div className="mt-1">
            <LineNozzles node={node} />
          </div>
        </>
      }
    </div>
  }

  const getLineContent = () => {
    return <LinePanel unit={unit as Edge} hasHeader={false} />
  }
  
  return <div className="unit-container">
    <div className={'unit-header flex-space-btw'}>
      <div>{isNode ? 'Node Setting' : 'Line Setting'}</div>
    </div>
    <div className="p-1">
      {isNode ? getNodeContent() : getLineContent()}
    </div>
  </div>
}